import slugify from "slugify";

export const scrollToTop = () => {
  window.scrollTo({ top: 0 });
};

export const formatDate = (isoDateStr) => {
  const date = new Date(isoDateStr);

  const day = date.getDate(); // Day of the month
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export function formatTime(dateString) {
  const date = new Date(dateString);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12;

  return `${hours}:${minutes}${ampm}`;
}

export function isValidURL(url) {
  const pattern = new RegExp(
    /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/,
    "i"
  );

  try {
    const formattedUrl = url.startsWith("http") ? url : `https://${url}`;
    const parsed = new URL(formattedUrl);
    return pattern.test(parsed.href);
  } catch {
    return false;
  }
}

export const generateSlugMap = (vendors) => {
  const slugCount = {};
  const slugMap = {};

  vendors.forEach((vendor) => {
    const baseSlug = slugify(vendor.company_name, {
      lower: true,
      strict: true,
    });
    const count = slugCount[baseSlug] || 0;

    const finalSlug = count === 0 ? baseSlug : `${baseSlug}-${count}`;
    slugCount[baseSlug] = count + 1;

    slugMap[finalSlug] = vendor._id;
  });
  return slugMap;
};

export const validateNationalInsuranceNumber = (niNumber) => {
  const errors = [];

  const cleanNI = niNumber.replace(/\s/g, "").toUpperCase();

  if (cleanNI.length !== 9) {
    errors.push("Must be exactly 9 characters long");
    return { isValid: false, errors };
  }
  const niPattern = /^[A-Z]{2}\d{6}[A-Z]$/;
  if (!niPattern.test(cleanNI)) {
    errors.push(
      "Must follow format: 2 letters, 6 numbers, 1 letter (e.g., AB123456C)"
    );
    return { isValid: false, errors };
  }

  const firstChar = cleanNI[0];
  const secondChar = cleanNI[1];
  const lastChar = cleanNI[8];
  const firstTwoChars = cleanNI.substring(0, 2);
  const invalidChars = ["D", "F", "I", "Q", "U", "V"];
  if (invalidChars.includes(firstChar)) {
    errors.push("First character cannot be D, F, I, Q, U, or V");
  }
  if (invalidChars.includes(secondChar)) {
    errors.push("Second character cannot be D, F, I, Q, U, or V");
  }
  if (secondChar === "O") {
    errors.push("Second character cannot be O");
  }
  const invalidCombinations = ["BG", "GB", "KN", "NK", "NT", "TN", "ZZ"];
  if (invalidCombinations.includes(firstTwoChars)) {
    errors.push(`First two characters cannot be ${firstTwoChars}`);
  }

  const validFinalChars = ["A", "B", "C", "D"];
  if (!validFinalChars.includes(lastChar)) {
    errors.push("Final character must be A, B, C, or D");
  }

  return {
    isValid: errors.length === 0,
    errors,
    formatted: cleanNI,
  };
};

export const convertToE164Format = (phoneNumber) => {
  if (!phoneNumber) return "";
  const cleanedNumber = phoneNumber.replace(/[\s\-\(\)]/g, "");

  if (cleanedNumber.startsWith("07")) {
    return "+44" + cleanedNumber.substring(1);
  }

  if (cleanedNumber.startsWith("+44")) {
    return cleanedNumber;
  }

  if (cleanedNumber.startsWith("0044")) {
    return "+44" + cleanedNumber.substring(4);
  }

  if (cleanedNumber.startsWith("44") && cleanedNumber.length >= 12) {
    return "+" + cleanedNumber;
  }

  return cleanedNumber;
};

export const formattedDate = (date) => {
  const newDate = new Date(date);
  const formatted = newDate.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  return formatted;
};



export const UK_PHONE_REGEX =
  /^(?:(?:\+44\s?|0044\s?|0)(?:\s?\d{4}\s?\d{3}\s?\d{3}|\s?\d{3}\s?\d{3}\s?\d{4}|\s?\d{2}\s?\d{4}\s?\d{4}|\s?7\d{3}\s?\d{6}))$/;